import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import MarketsLayout from '@fuww/library/src/Markets';
import Head from '../Head';
import messages from '../../lib/messages.json';

const MarketPlaceHeading = ({ breadcrumbs, tabs, children }) => {
  const intl = useIntl();

  return (
    <>
      <Head
        title={intl.formatMessage(messages['markets.title'])}
        description={
          intl.formatMessage(messages['markets.description'])
        }
      />
      <MarketsLayout
        title={intl.formatMessage(messages['markets.title'])}
        description={
          intl.formatMessage(messages['markets.description'])
        }
        breadcrumbs={breadcrumbs}
        tabs={tabs}
      >
        {children}
      </MarketsLayout>
    </>
  );
};

MarketPlaceHeading.propTypes = {
  breadcrumbs: PropTypes.node.isRequired,
  tabs: PropTypes.node,
  children: PropTypes.node,
};

MarketPlaceHeading.defaultProps = {
  tabs: null,
  children: null,
};

export default MarketPlaceHeading;
